/**
 * PRE-LAUNCH MODE, client side — the switch that turns the whole website into one landing page pointing at the
 * Kickstarter, between announcing the project and the campaign going live. Set on the admin console
 * (Admin → Pre-launch); every visitor learns it from /api/config at boot (sim/env.ts), and ui/site/PrelaunchGate
 * shows the page to everyone who is not an admin. The server enforces it as well: every gameplay route refuses
 * non-admins while it is on (server/index.js requireNotMaintenance), so a direct /play link plays nothing.
 *
 * `coercePrelaunch` MIRRORS the server's (server/index.js) — off unless `on === true`, the Kickstarter link http(s)
 * only, the banner an http(s) URL, an uploaded image (/api/media/…) or a file the site ships (/site/…).
 */
export interface PrelaunchConfig {
  on: boolean;
  /** where the banner and the button go — the Kickstarter page ("" until there is one) */
  kickstarterUrl: string;
  /** the banner image ("" = the built-in one, DEFAULT_PRELAUNCH_BANNER) */
  bannerUrl: string;
  /** the big line ("" = DEFAULT_PRELAUNCH_HEADLINE) */
  headline: string;
  /** one optional line under it */
  note: string;
}

export const PRELAUNCH_OFF: PrelaunchConfig = { on: false, kickstarterUrl: "", bannerUrl: "", headline: "", note: "" };
export const DEFAULT_PRELAUNCH_BANNER = "/site/prelaunch-banner.jpg";
export const DEFAULT_PRELAUNCH_HEADLINE = "Coming soon to Kickstarter";

export function coercePrelaunch(raw: unknown): PrelaunchConfig {
  const o = raw && typeof raw === "object" && !Array.isArray(raw) ? raw as Record<string, unknown> : {};
  const str = (v: unknown, n: number) => (typeof v === "string" ? v.trim().slice(0, n) : "");
  const url = str(o.kickstarterUrl, 300);
  const banner = str(o.bannerUrl, 500);
  return {
    on: o.on === true,
    kickstarterUrl: /^https?:\/\//i.test(url) ? url : "",
    bannerUrl: /^(https?:\/\/|\/api\/media\/|\/site\/)/i.test(banner) ? banner : "",
    headline: str(o.headline, 90),
    note: str(o.note, 280),
  };
}
